/* unplugin-vue-components disabled */import script from "./header.vue?vue&type=script&setup=true&lang=js"
export * from "./header.vue?vue&type=script&setup=true&lang=js"

import "./header.vue?vue&type=style&index=0&id=0fdeec6e&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/48tk_gai/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fdeec6e"]])

export default __exports__